import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="itemized-bill-subtasks"
export default class extends Controller {
  static targets = [
    "subtasksContainer",
    "connectContainer"
  ]

  connect() {
  }

  toggleSubtasks(event) {
    event.preventDefault()
    this.subtasksContainerTarget.classList.toggle("hidden")
    this.connectContainerTarget.classList.toggle("hidden")
  }
}
